var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-ideasoft-channel-form" } },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "a-alert",
              { attrs: { message: "Redirect URL", type: "success" } },
              [
                _c(
                  "div",
                  { attrs: { slot: "description" }, slot: "description" },
                  [
                    _c("div", { staticClass: "webhook-info" }, [
                      _c(
                        "span",
                        [
                          _c("a-icon", {
                            attrs: { type: "copy" },
                            on: { click: _vm.copyWebhookAddress },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getWebhookAddress()))]),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper d-none" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("channelName"),
                      help: _vm.getErrorMessage("channelName"),
                    },
                  },
                  [
                    _c("a-input", {
                      ref: "channelName",
                      attrs: {
                        placeholder: _vm.$t("whatsappChannel.channelName"),
                        name: "channelName",
                      },
                      model: {
                        value: _vm.form.channelName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelName", $$v)
                        },
                        expression: "form.channelName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.websiteAddress")))]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    "addon-before": "https://",
                    "addon-after": ".myideasoft.com",
                    name: "domain",
                  },
                  model: {
                    value: _vm.form.domain,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "domain", $$v)
                    },
                    expression: "form.domain",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Client ID")]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: "Ideasoft API Client ID",
                    name: "clientId",
                  },
                  model: {
                    value: _vm.form.clientId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "clientId", $$v)
                    },
                    expression: "form.clientId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Client Secret")]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: "Ideasoft API Client Secret",
                    name: "clientSecret",
                  },
                  model: {
                    value: _vm.form.clientSecret,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "clientSecret", $$v)
                    },
                    expression: "form.clientSecret",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("mail.connect")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }